import React, { useEffect } from 'react';
import { translate } from 'react-i18next';
import { RadioGroup, Radio } from 'rsuite';
import AdminStepCard from '../../../components/AdminStepCard/AdminStepCard';
import "./Coverage.scss";
import ToggleWithInfo from '../../../components/ToggleWithInfo/ToggleWithInfo';
import { Coverages, CoveragesKeys } from '../../../Enums/Coverages';
import { PlanTypes } from '../../../Enums/PlanTypes';

const workplanCoverages = [
    Coverages.pushCoverageRolloutWorkplan,
    Coverages.pushCoverageEditRolloutWorkplan,
    Coverages.pushCoveragePauseWorkplan,
    Coverages.pushCoverageEditPauseWorkplan,
    Coverages.pushCoverageStopWorkplan,
];

const shiftlineCoverages = [
    Coverages.pushCoverageAddShiftline,
    Coverages.pushCoveragePauseShiftline,
    Coverages.pushCoverageStopShiftline,
];

const Coverage = ({values, handleSettingPropChange, isUsed, ...props}) => {
    const {t: translate} = props;
    const t = (prop) => translate(`workplanManager:settings.coverage.${prop}`);

    const handleCoverageChange = (propName, prop) => handleSettingPropChange('coverage', {...values, [propName]: prop || null})
    const handleVisibilityChange = (value) => handleCoverageChange('enableSystemCoverage', value)

    const handleWorkplanSwitchChange = (value) => {
        if (value === false) {
            handleSettingPropChange('coverage', {
                ...values,
                pushCoverageRolloutWorkplan: null,
                pushCoverageEditRolloutWorkplan: null,
                pushCoveragePauseWorkplan: null,
                pushCoverageEditPauseWorkplan: null,
                pushCoverageStopWorkplan: null,
                isEnabledWorkplanCoverage: false,
             });
        } else {
            handleCoverageChange('isEnabledWorkplanCoverage', value);
        }
    }

    const handleShiftlineSwitchChange = (value) => {
        if (value === false) {
            handleSettingPropChange('coverage', {
                ...values,
                pushCoverageAddShiftline: null,
                pushCoveragePauseShiftline: null,
                pushCoverageStopShiftline: null,
                isEnabledShiftlineCoverage: false,
             });
        } else {
            handleCoverageChange('isEnabledShiftlineCoverage', value)
        }

    };

    const isValueInWorkplanCoverage = () => {
        let isAllNulls = true;
        workplanCoverages.forEach((x) => {
            if (values[CoveragesKeys[x]] !== null) isAllNulls = false;
        })
        return !isAllNulls;
    }

    const isValueInShiftlineCoverage = () => {
        let isAllNulls = true;
        shiftlineCoverages.forEach((x) => {
            if (values[CoveragesKeys[x]] !== null) isAllNulls = false;
        })
        return !isAllNulls;
    }

    useEffect(()=> {
        const isEnabledWorkplanCoverage = isValueInWorkplanCoverage();
        const isEnabledShiftlineCoverage = isValueInShiftlineCoverage();
        handleSettingPropChange('coverage', {...values, isEnabledWorkplanCoverage, isEnabledShiftlineCoverage })
    }, [])

    const CoverageRadioGroup = ({type}) => {
        const key = CoveragesKeys[type]
        const value = values[key] == null ? null : Number(values[key]);
        return (
            <RadioGroup
                className='coverage-radio-group'
                value={value}
                disabled={isUsed}
                onChange={(value) => handleCoverageChange(key, value)}
            >
                <span className='radio-label'>{t(key)}</span>
                <Radio value={null}></Radio>
                <Radio value={PlanTypes.plan}></Radio>
                <Radio value={PlanTypes.budget}></Radio>
            </RadioGroup>
        );
    }

    const RadioValuesBox = () => (
        <div className='radio-value-container'>
            <span></span>
            <span className='radio-value'>{t('none')}</span>
            <span className='radio-value'>{t('plan')}</span>
            <span className='radio-value'>{t('budget')}</span>
        </div>);

    return (
        <AdminStepCard avatar={5} title={t('title')}>
            <div className='coverage-container'>
                <ToggleWithInfo
                    disabled={isUsed}
                    checked={values.isEnabledWorkplanCoverage}
                    label={t('switch.workplan')}
                    onChange={handleWorkplanSwitchChange}
                />

                {values.isEnabledWorkplanCoverage && (
                    <div className='radio-container'>
                        <RadioValuesBox/>
                        {workplanCoverages.map((type) => (
                            <CoverageRadioGroup key={`radio-${type}`} type={type}/>
                        ))}
                    </div>
                )}

                <ToggleWithInfo
                    disabled={isUsed}
                    checked={!!values.isEnabledShiftlineCoverage}
                    label={t('switch.shiftlines')}
                    onChange={handleShiftlineSwitchChange}
                />
                {values.isEnabledShiftlineCoverage && (
                    <div className='radio-container'>
                        <RadioValuesBox/>
                        {shiftlineCoverages.map((type) => (
                            <CoverageRadioGroup key={`radio-${type}`} type={type}/>
                        ))}
                    </div>
                )}

                <ToggleWithInfo
                    disabled={isUsed}
                    checked={values.enableSystemCoverage}
                    label={t('switch.visibility')}
                    info={t("info.visibility")}
                    onChange={handleVisibilityChange}/>
            </div>
        </AdminStepCard>
    )
}

export default translate('workplanManager')(Coverage);
